export default "__VITE_ASSET__SZThdWLJ__"